
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface AvailableStock {
  id: string;
  symbol: string;
  name: string;
  category: 'domestic' | 'international';
  is_active: boolean;
}

export const useAvailableStocks = () => {
  return useQuery({
    queryKey: ['available-stocks'],
    queryFn: async () => {
      console.log('Fetching available stocks...');
      const { data, error } = await supabase
        .from('available_stocks')
        .select('*')
        .eq('is_active', true)
        .order('category', { ascending: true })
        .order('name', { ascending: true });

      if (error) {
        console.error('Error fetching stocks:', error);
        throw error;
      }

      console.log('Fetched stocks:', data);
      return data as AvailableStock[];
    },
  });
};
